// middleware
import store from '@/store/'
import auth from '@/middleware/modules/auth'
import suspended from '@/middleware/modules/suspended'
import onboarding from '@/middleware/modules/onboarding'
import route404 from '@/middleware/modules/404'
import impersonate from '@/middleware/modules/impersonate'

// routes parts
import authRoutes from '@/router/parts/auth.js'
import boardsRoutes from '@/router/parts/boards.js'
import campaignsRoutes from '@/router/parts/campaigns.js'
import creatorsRoutes from '@/router/parts/creators.js'
import virtualInfluencersRoutes from '@/router/parts/virtual_influencers.js'

import accountRoutes from '@/router/parts/account.js'
import feedRoutes from '@/router/parts/feeds.js'
import embedsRoutes from '@/router/parts/embeds.js'
import queriesRoutes from '@/router/parts/queries.js'
import schedulesRoutes from '@/router/parts/schedule.js'
import InstagramAnalyticsRoutes from '@/router/parts/instagram_analytics.js'
import businessprofileAnalytics from './parts/businessprofile'
import embedAnalytics from './parts/embed_analytics'
// import creativeStudio from './parts/creative_studio'

import socialBoostRoutes from '@/router/parts/social_boost.js'

// components
const Dashboard = () => import(/* webpackChunkName: "_v-dashboard" */ '@/views/dashboard/Index.vue')
const Empty = () => import(/* webpackChunkName: "_v-suspended_404" */ '@/views/suspended_404/Empty.vue')
const Subscription = () => import(/* webpackChunkName: "_v-membership" */ '@/views/membership/Subscription.vue')

const StyleGuide = () => import(/* webpackChunkName: "_v-account" */ '@/views/styleguide/Index.vue')
const Charts = () => import(/* webpackChunkName: "_v-account" */ '@/views/styleguide/charts.vue')

var devRoutes = []
if (store.getters.is_dev) {
  devRoutes = [
    // styleguide. DEV only
    {
      path: '/styleguide',
      name: 'styleguide',
      component: StyleGuide,
      meta: {
        layout: 'app-layout',
        middleware: [auth],
      },
    },
    {
      path: '/charts',
      name: 'charts',
      component: Charts,
      meta: {
        layout: 'app-layout',
        middleware: [auth],
      },
    },
  ]
}

export default [
  // auth routes
  ...authRoutes,

  // dashbboard main routes
  {
    path: '/',
    component: {
      render(h) {
        return h('router-view')
      },
    },
    /* Explicitly tell the router to redirect to default children */
    name: 'dashboard',
    redirect: { name: 'dashboard-child' },
    meta: {
      layout: 'app-layout',
      middleware: [auth],
    },
    children: [
      {
        path: '',
        name: 'dashboard-child',
        component: Dashboard,
        meta: {
          layout: 'app-layout',
          middleware: [auth],
        },
      },

      // onboarding
      {
        path: '/subscription',
        name: 'subscription',
        component: Subscription,
        meta: {
          layout: 'app-layout',
          middleware: [onboarding],
        },
      },

      // suspended
      {
        path: 'suspended',
        name: 'suspended',
        component: Empty,
        meta: {
          layout: 'app-layout',
          middleware: [suspended],
        },
      },

      {
        path: '/referral-campaign',
        name: 'referral-campaign',
        component: () => import('@/views/campaigns/Referral/ReferralCampaign.vue'),
        meta: {
          layout: 'app-layout',
          middleware: [auth],
        },
      },

      {
        path: '/social-inbox',
        name: 'social-inbox',
        component: () => import('@/views/social-inbox/Index.vue'),
        meta: {
          layout: 'app-layout',
          middleware: [auth],
        },
      },

      {
        path: '/ai-assistant',
        name: 'ai-assistant',
        component: () => import('@/views/ai-assistant/Index.vue'),
        meta: {
          layout: 'app-layout',
          middleware: [auth, impersonate],
        },
      },
      // Visual Commerce //
      // query routes
      ...queriesRoutes,

      // schedules
      ...schedulesRoutes,

      // boards routes
      ...boardsRoutes,

      // campaigns routes
      ...campaignsRoutes,

      // creators campaigns routes
      ...creatorsRoutes,

      // virtual influencers (admin + PM only)
      ...virtualInfluencersRoutes,

      // creators onboarding routes
      // ...creatorsOnboardingRoutes,

      // embeds routes
      ...embedsRoutes,

      // feed routes
      ...feedRoutes,

      // account routes
      ...accountRoutes,

      // Instagram Analytics routes
      ...InstagramAnalyticsRoutes,

      // development routes
      ...devRoutes,

      // Embed analytics routes
      ...embedAnalytics,

      // businessprofile routes
      ...businessprofileAnalytics,

      // creative v3
      // ...creativeStudio,
      ...socialBoostRoutes,
    ],
  },

  // 404
  {
    path: '*',
    name: 'NotFound',
    meta: { layout: 'simple-layout', middleware: [route404] },
    component: Empty,
  },
]
